import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiFileText } from 'react-icons/fi';
import { rowTooltipProps } from './rowTooltip';

// The list row carries only the `has_note` boolean — never the note text — so
// this marks that notes exist; the instance viewer's Notes tab shows them.
const NoteIndicator = () => (
  <OverlayTrigger placement="top" {...rowTooltipProps} overlay={<Tooltip>Has note</Tooltip>}>
    <span className="d-inline-flex align-items-center text-900" role="img" aria-label="Has note">
      <FiFileText />
    </span>
  </OverlayTrigger>
);

export default NoteIndicator;
